export const isLicenseExpired = (expirationDate) => {
    if (!expirationDate) return true;
    const expDate = new Date(expirationDate);
    const now = new Date();
    return expDate <= now;
};

export const getLicenseStatus = (asset) => {
    const isExpired = isLicenseExpired(asset.ExpirationDate);

    if (isExpired) {
        return { status: 'expired', daysUntilExpiry: -1 };
    }

    // Calculate days until expiry for non-expired licenses
    const expDate = new Date(asset.ExpirationDate);
    const now = new Date();
    const timeDiff = expDate.getTime() - now.getTime();
    const daysUntilExpiry = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (daysUntilExpiry <= 7) {
        return { status: 'expiring_soon', daysUntilExpiry };
    } else {
        return { status: 'active', daysUntilExpiry };
    }
};